export function defined ( thing ) {
    if ( thing === null || thing === undefined ) {
        throw new Error( 'Unexpected ' + thing );
    }
    return thing;
}
